import { useClientPortalConfigContext } from "../../context";
import { InvoicesModel } from "../../types/generated/models";
import { useGetQuery } from "../../hooks/useClientPortalQuery";

export type IInvoicesHook = InvoicesModel & {
    isLoading: boolean;
};

export function useInvoices(): IInvoicesHook {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { data, isLoading } = useGetQuery<InvoicesModel>({
        url: `/api/v1/${clientPortalGuid}/Invoices`,
    });

    return {
        invoices: data?.invoices ?? [],
        unpaidInvoicesIds: data?.unpaidInvoicesIds ?? [],
        uniquePayee: data?.uniquePayee,
        hasUnpaidInvoices: data?.hasUnpaidInvoices,
        isLoading,
    };
}
